module.exports = __webpack_public_path__ + "img/aiimg7.a74871a7.png";